<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Ward Preview"
      id="admin_edit_ward_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Edit
      </v-btn>
      <v-btn
        :to="
          '/admin/locations/wards/view/' +
          $route.params.id +
          '/delete'
        "
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-trash-can</v-icon> Remove Ward
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="ward.name"
        :icon="'mdi-flag'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1605951043/botswana%20services/website%20assets/ward_w66wvu.png'"
        :facts="view_header_facts"
        :description="''"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Edit Ward Form"
      id="admin_edit_ward_form"
    ></CardedSectionHeader>
    <AdminWardsAdd
      @on-show-loader="show_loader"
      @on-hide-loader="hide_loader"
      :is_editing="true"
      :is_loading="is_loading"
      ref="add_ward_form_comp_ref"
      @on-success-edit="on_success_edit"
    >
    </AdminWardsAdd>
  </div>
</template>
<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import ViewHeader from "../../../components/ViewHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import AdminWardsAdd from "./AdminWardsAdd";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminWardsEdit",
  components: {
    CardedSectionHeader,
    ViewHeader,
    CardedDisplay,
    AdminWardsAdd,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      ward: {
        id: 0,
        name: "",
        country: {
            id: 0,
            name: ""
        },
        district: {
            id: 0,
            name: ""
        },
        city: {
            id: 0,
            name: ""
        }
      },
    };
  },
  methods: {
    show_loader() {
      this.$emit("on-show-loader");
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    load_item(){
      ServerClient.Locations.get_ward(
      {
        id: this.$route.params.id,
        is_edit: true,
      },
      (res) => {
        this.$emit("on-hide-loader");
        this.ward = res;
        var edit = {
            ...res
        };
        delete edit.country;
        delete edit.district;
        delete edit.city;
        this.$refs.add_ward_form_comp_ref.fill_edit_ward(edit);
      },
      (errors) => {
        this.$emit("on-hide-loader");
        console.log(
          "Errors while loading ward details on admin edit ward",
          errors
        );
      }
    );
    },
    on_success_edit(){
      this.load_item();
    }
  },

  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "City",
          val: this.ward.city.name,
        },
        { text: "District:", val: this.ward.district.name },
        { text: "Country:", val: this.ward.country.name },
      ];
      return facts;
    },
  },

  mounted() {
    var item_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin Edit Ward",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Wards",
          disabled: false,
          href: "/admin/locations/wards/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/locations/wards/list/view/" + item_id,
        },
        {
          text: "Edit",
          disabled: true,
          href:"/admin/locations/wards/list/view/"+item_id+"/edit" 
        }
      ],
      navbar_cols: 3
    });
    this.load_item();
  },
};
</script>

